import { Timestamp } from "firebase/firestore";

export function stringifyReplacingTimestamps(obj: any) {
  let stringObj = JSON.stringify(obj, (key, value) => {
    // the client-side firestore Timestamp class defines a toJSON() that encodes as { seconds: 234, nanoseconds: 1234 }
    if (value && typeof value === "object") {
      if ("seconds" in value && "nanoseconds" in value) {
        return new Timestamp(value.seconds, value.nanoseconds)
          .toDate()
          .toISOString();
      }
    }
    return value;
  });
  return stringObj;
}

/***
 * convert all timestamps to ISO strings in an object
 */
export function serialiseTimestamps(obj: any) {
  return JSON.parse(stringifyReplacingTimestamps(obj));
}

/****
 * Timestamps sent over the wire get JSON.stringify'd to an object with _seconds and _nanoseconds
 * This function deserialises them back into a Timestamp object
 *
 * We also check for ISO strings and convert them to Timestamps
 */
export function deserialiseTimestamps(
  obj: any,
  // this gets around using the Firebase admin sdk and local sdk versions of Timestamp
  toTimestamp: (date: Date) => Timestamp
) {
  if (obj === null || obj === undefined) {
    return obj;
  }

  // obj must be an Object we can JSON.serialise
  if (typeof obj !== "object") {
    return obj;
  }

  let objString = JSON.stringify(obj);

  let parsedObj = JSON.parse(objString, (key, value) => {
    if (value) {
      if (typeof value === "string") {
        // If it's an ISO string
        if (value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/)) {
          let d = new Date(value);
          if (isNaN(d.getTime())) {
            return value;
          }
          return toTimestamp(d);
        }
      }

      if (
        typeof value === "object" &&
        "_seconds" in value &&
        "_nanoseconds" in value
      ) {
        // If it's a serialised timestamp
        // e.g. {_seconds: 1749218700, _nanoseconds: 0}
        let d = new Date(value._seconds * 1000);
        if (isNaN(d.getTime())) {
          return value;
        }
        return toTimestamp(d);
      }
    }

    return value;
  });
  return parsedObj;
}
